import type { ExportColumnConfig } from "@/types/exportFeatures";

export const INVOICE_SPECIFICATION_EXPORT_COLUMN_CONFIG: ExportColumnConfig = {
  client_store_number: "invoiceSpecificationExport.columns.clientStoreNumber",
  apartment_number: "invoiceSpecificationExport.columns.apartmentNumber",
  role_or_department: "invoiceSpecificationExport.columns.roleOrDepartment",
  hours: "invoiceSpecificationExport.columns.hours",
  rate: "invoiceSpecificationExport.columns.rate",
  deduction: "invoiceSpecificationExport.columns.deduction",
  addition: "invoiceSpecificationExport.columns.addition",
  comment: "invoiceSpecificationExport.columns.comment",
};

const STORAGE_KEY_PREFIX = "invoiceSpecificationExportColumns";

export function getInvoiceSpecificationExportStorageKey(
  userId: string,
): string {
  return `${STORAGE_KEY_PREFIX}_${userId}`;
}
